import React from "react";
import {Grid} from "@material-ui/core";
import QuestionMark from "../../../assets/images/q_mark.png";
import GoldBanner from "../../../assets/images/gold_banner.png";
import Button from "../Settings/Free/Button";
class BoxDialog extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {success,
            type,
            strAction,
            action,
            imgUrl,
            message,
            light,
            prizeType,
            prizeVal}=this.props.data

        const okButton={
            text:'بریم بازی',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
            action:'game'
        }
        const cancelButton={
            text:'بازگشت',
            backgroundColor:'red',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
            action:'close'
        }
        return(
            <>
                <Grid direction={"column"} item container
                    className={'help-dialog'}
            >
                <Grid container alignItems={"center"} style={{position:'relative'}} justify={"center"}>
                    <Grid  xs={6} sm={6} container alignItems={"center"} justify={"center"}
                           style={{
                               marginTop:'-60%',
                               backgroundImage: "url(" + light + ")",
                               backgroundSize:'cover',
                               backgroundRepeat: 'no-repeat',
                               height:'150px',
                               backgroundPosition:'center',
                               position:'absolute'
                           }}>
                        <Grid xs={6} sm={6} container alignItems={"center"} justify={"center"}>
                            <img src={imgUrl} alt=""/>
                        </Grid>
                    </Grid>
                    <Grid className={'help-dialog-inner'} sm={10} xs={10} alignItems={"center"} justify={"center"}
                          style={{
                              whiteSpace: 'pre-line',
                              textAlign: 'center'
                          }}
                    >
                        {message}
                    </Grid>
                </Grid>
            </Grid>
                <Grid style={{transform: 'translateY(-40%)'}} sm={12} xs={12} alignItems={"center"}  direction={"row-reverse"} justify={"space-around"} container>
                    {
                        <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"} justify={"center"}
                              onClick={()=>{
                                  this.props.action(okButton.action)
                              }} container style={{height: '50px'}}>
                            <Button data={okButton}/>
                        </Grid>
                    }
                    {
                        <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{height:'50px'}}
                              onClick={()=>{
                                  this.props.action(cancelButton.action)
                              }}
                        >
                            <Button data={cancelButton}/>
                        </Grid>
                    }
                </Grid>
            </>

        )
    }
}
export default BoxDialog